import React, { useContext, useEffect, useMemo, useState } from "react";

import './GrillasStyles.css';
import controlContext from "../../context/control/controlContext";
import authContext from "../../context/authentication/authContex";
import informesContext from "../../context/informesContext/informesContext";
import { STATES } from "../../utils/states";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";
import normalizeText from "../../utils/normalizeText";

const GrillaTareasODT = ({ setGridToShow }) => {

    const cContext = useContext(controlContext);
    const {
        listTDocReporte,
        filtrosRango,
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltrosReporte,
        filtrar
    } = cContext;

    const uContext = useContext(usuariosContext);
    const { userListView, saveColumnsPreferences } = uContext;

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const iContext = useContext(informesContext);
    const { generarInformeExcel } = iContext;

    let columnsPreferences = useMemo(() => usuario?.columnsPreferences?.columnasTareasODT ?? [], [usuario]);

    const [columns, setColumns] = useState([
        { width: 200, property: 'fecAlt', title: 'Fecha de Alta', visible: true },
        { width: 200, property: 'fechaCompletado', title: 'Fecha Completada', visible: true },
        { width: 100, property: 'tDocCodFor', title: 'Código OT', visible: true },
        { width: 100, property: 'tDocNroFor', title: 'Número OT', visible: true },
        { width: 350, property: 'titleOT', title: 'Título OT', visible: true },
        { width: 150, property: 'stateOT', title: 'Estado OT', visible: true },
        { width: 300, property: 'codTarea', title: 'Código Tarea', visible: true },
        { width: 275, property: 'nameTarea', title: 'Nombre Tarea', visible: true },
        { width: 400, property: 'taskDescrp', title: 'Texto Adicional', visible: true },
        { width: 400, property: 'descrp', title: 'Descripción Tarea', visible: true },
        { width: 125, property: 'done', title: 'Completada', visible: true },
        { width: 150, property: 'codActivo', title: 'Código Activo', visible: true },
        { width: 250, property: 'activo', title: 'Activo', visible: true },
        { width: 100, property: 'userName', title: 'Usuario', visible: true },
    ]);

    const [permanentRows, setPermanentRows] = useState(undefined);
    const [rowsFiltered, setRowsFiltered] = useState(undefined);
    const [filter, setFilter] = useState('');
    const [showFilters, setShowFilter] = useState(false);
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({ todos: 1, pendientes: 0, disponibles: 0 });
    const [selct, setSelec] = useState([]);
    const [loading, setLoading] = useState(true);

    const handlerIniciarlizarFiltros = async () => {
        const state = STATES;
        let res = await iniciarFiltrosReporte(state, usuario);
        return res;
    }

    const handleGenerarInforme = async () => {
        let dataToExcel = [];
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title);
        dataToExcel.push(columnsTitle);

        for (const row of rowsFiltered) {
            let rowModelado = [];
            for (const col of columns) {
                if (!col.visible) continue;
                if (col.property === 'fecAlt') {
                    rowModelado.push(row[col.property]?.toLocaleString().substring(0, 16).replace("T", " ") ?? '');
                } else if (col.property === 'done') {
                    rowModelado.push(row[col.property] ? 'Completada' : 'Pendiente');
                } else {
                    rowModelado.push(row[col.property] ?? '');
                }
            }
            if (rowModelado.length > 0) dataToExcel.push(rowModelado);
        }
        await generarInformeExcel(dataToExcel, 'TareasODT');
    }

    const handleChangeColumnsVisible = (e, c, i) => {
        setColumns((prevCols) => prevCols.map((c, index) => index == i ? { ...c, visible: e.target.checked } : c));
    }

    const handlerClickFilter = () => {
        setShowFilter(false);
    }

    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    // Explota las OTs en filas de tareas: una fila por tarea
    const flattenOTsToTareas = (ots) => {
        if (!ots) return undefined;
        let rows = [];
        for (const ot of ots) {
            if (ot.tareas && ot.tareas.length > 0) {
                for (const t of ot.tareas) {
                    console.log("t");
                    console.log(t);
                    
                    rows.push({
                        fecAlt: ot.fecAlt,
                        fechaCompletado: ot.fechaCompletado || '',
                        tDocCodFor: ot.tDocCodFor,
                        tDocNroFor: ot.tDocNroFor,
                        titleOT: ot.title,
                        stateOT: ot.state,
                        codTarea: t.codTarea || t.value || '',
                        nameTarea: t.name || t.label || '',
                        taskDescrp: t.taskDescrp || '',
                        done: t.done || '',
                        descrp: t.descrp || '',
                        codActivo: t.codActivo || ot.codActivo || '',
                        activo: t.activoNombre || ot.activo || '',
                        userName: ot.userName || '',
                    });
                }
            } else {
                // OT sin tareas: mostrar fila con datos de OT
                rows.push({
                    fecAlt: ot.fecAlt,
                    fechaCompletado: ot.fechaCompletado || '',
                    tDocCodFor: ot.tDocCodFor,
                    tDocNroFor: ot.tDocNroFor,
                    titleOT: ot.title,
                    stateOT: ot.state,
                    codTarea: '',
                    nameTarea: '',
                    taskDescrp: '',
                    done: false,
                    descrp: '',
                    codActivo: ot.codActivo || '',
                    activo: ot.activo || '',
                    userName: ot.userName || '',
                });
            }
        }
        return rows;
    }

    useEffect(() => {
        const fn = async () => {
            handlerIniciarlizarFiltros()
                .then(() => {
                    setLoading(false);
                })
        }
        fn();
    }, []);

    useEffect(() => {
        if (filter !== '') {
            const nFilter = normalizeText(filter);
            let filtered = permanentRows?.filter(r =>
                normalizeText(r.nameTarea || '').includes(nFilter) ||
                normalizeText(r.codTarea || '').includes(nFilter) ||
                normalizeText(r.titleOT || '').includes(nFilter) ||
                normalizeText(`${r.tDocCodFor} - ${r.tDocNroFor}`).includes(nFilter) ||
                normalizeText(r.codActivo || '').includes(nFilter)
            );
            setRowsFiltered(filtered);
        } else {
            setRowsFiltered(permanentRows);
        }
    }, [filter]);

    useEffect(() => {
        let listTDocReporteCopy = (listTDocReporte == undefined) ? undefined : listTDocReporte.slice();
        let resFiltered = filtrar(listTDocReporteCopy, filtrosEstado, undefined, 'ReportesODT');
        if (resFiltered) {
            let rows = flattenOTsToTareas(resFiltered);
            setPermanentRows(rows);
            setRowsFiltered(rows);
        } else {
            setPermanentRows(undefined);
            setRowsFiltered(undefined);
        }
    }, [listTDocReporte, filtrosEstado, filtrosRango]);

    useEffect(() => {
        if (columnsPreferences && columnsPreferences.length > 0) {
            setColumns(prevColumns => prevColumns.map(c => ({ ...c, visible: columnsPreferences.includes(c.property) })));
        }
    }, [columnsPreferences]);

    console.log("rowsFiltered");
    console.log(rowsFiltered);

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={() => setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong} /></button>
            <SearchInput filter={filter} buscar={setFilter} />
            <FilterScreen verFiltro={setShowFilter} />
            <button className="selectColumnsBtn" onClick={() => setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells} /></button>
            <button disabled={loading || rowsFiltered == undefined || rowsFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload} /></button>
        </div>
        {
            (rowsFiltered == undefined || loading) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (rowsFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay tareas asociadas a ordenes de trabajo</h3> : <Table array={rowsFiltered} columns={columns} setColumns={setColumns} />
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"TareasODT"} />
        }
        {showFilters &&
            <div className="addFilterContainer">
                <AddFilter
                    usuarios={userListView}
                    item={selectedFilter}
                    cerrar={handlerClickFilter}
                    filtro={{ filtrosRango, filtrosEstado }}
                    aplicarFiltros={apFiltros}
                    workspace={activeWorkSpace}
                    selct={selct}
                    setSelec={setSelec}
                    componentePadre="ReportesODT"
                />
            </div>
        }
    </div>
}

export default GrillaTareasODT;
